import { createAction } from '@wix/communities-blog-client-common';

export const SET_ROUTER_MATCH = 'router/SET_MATCH';

export const setRouterMatch = createAction(SET_ROUTER_MATCH);
